import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children, darkMode = false }) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const closeMobileSidebar = () => {
    setMobileSidebarOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#F8FAFC",
        fontFamily: "Montserrat, sans-serif",
        overflowX: "hidden",
      }}
    >
      {/* Sidebar */}
      <Sidebar 
        darkMode={darkMode} 
        isMobile={isMobile}
        isOpen={mobileSidebarOpen}
        closeSidebar={closeMobileSidebar}
      />

      {/* Main Content Area */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          width: "100%",
          marginLeft: { xs: "0", md: "280px" },
          transition: "margin-left 0.3s ease",
        }}
      >
        {/* Header */}
        <Header 
          isMobile={isMobile} 
          toggleSidebar={toggleMobileSidebar}
        />

        {/* Page Content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            padding: { 
              xs: "12px", 
              sm: "16px", 
              md: "20px", 
              lg: "24px" 
            },
            overflow: "auto",
            backgroundColor: "#F8FAFC",
            maxWidth: "100%",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;